// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"594":"d55bee18","747":"df110ad3","856":"df110ad3"}[chunkId] + ".chunk.css";
};